// 路由配置页面


/**
 * 使用asyncComponent动态导入组件
 */
import asyncComponent from '../../asyncComponent';
/**
 * 导入页面入口
 */
function loadLayouts(component) {
    return import(`../../layouts/${component}`)//$pages在webpack里面配置过是“./src/pages”的别名
}
const AppLoyout = asyncComponent(() => loadLayouts('mainLayout')); // 页面入口

/**
 * 导入pages下用户端页面
 */
function loadApp(component) {
    return import(`../../pages/${component}`)//$pages在webpack里面配置过是“./src/pages”的别名
}/**
 * 导入business下商家端页面
 */
function loadBusiness(component) {
    return import(`../../business/${component}`)//$pages在webpack里面配置过是“./src/business
}

const businessEntryRedirect =
    process.env.REACT_APP_BUSINESS_SKIP_LOGIN === 'true'
        ? '/business/app/order/1'
        : '/business/login';

const routerConfig = [
    // 商家端
    {
        path: '/business',
        component: AppLoyout,
        children: [
            {
                path: '/',
                redirect: businessEntryRedirect,
            }, {
                path: '/login',
                component: asyncComponent(() => loadBusiness('login')), // 登录页面,
                children: [],
            }, {
                path: '/app',
                component: asyncComponent(() => loadBusiness('home')), // C端--入口,
                children: [
                    {
                        path: '/',
                        redirect: '/business/app/order',
                    }, {
                        path: '/order',
                        component: asyncComponent(() => loadBusiness('order')), // 订单
                    }, {
                        path: '/commodity',
                        component: asyncComponent(() => loadBusiness('commodity')), // 商品
                    }, {
                        path: '/setUp',
                        component: asyncComponent(() => loadBusiness('setUp')), // 设置
                    }, 
                ]
            }, {
                path: '/storeSetUp',
                component: asyncComponent(() => loadBusiness('storeSetUp')), // 门店设置,
                children: []
            }, {
                path: '/orderDetails',
                component: asyncComponent(() => loadBusiness('orderDetails')), // 订单详情,
                children: []
            },
        ]
    }, 
    // 用户端
    {
        path: '/',
        component: AppLoyout,
        children: [
            {
                path: '/',
                redirect: '/app/home',
            }, {
                path: '/app',
                component: asyncComponent(() => loadApp('app')), // C端--入口,
                children: [
                    {
                        path: '/',
                        redirect: '/app/home',
                    }, {
                        path: '/home',
                        component: asyncComponent(() => loadApp('home')), // 首页
                    }, {
                        path: '/discover',
                        component: asyncComponent(() => loadApp('discover')), // 发现
                    }, {
                        path: '/shoppingCart',
                        component: asyncComponent(() => loadApp('myShoppingCart')), // 购物车
                    }, {
                        path: '/order',
                        component: asyncComponent(() => loadApp('myOrder')), // 订单
                    }, {
                        path: '/my',
                        component: asyncComponent(() => loadApp('myMessage')), // 我的
                    }, 
                ]
            }, 
            {
                path: '/cmsPage',
                component: asyncComponent(() => loadApp('cmsPage')), // 活动页面
                children: [],
            },
            {
                path: '/selectProvider',
                component: asyncComponent(() => loadApp('selectProvider')), // 选择店铺（cms活动优惠券）
                children: [],
            },
            {
                path: '/groupActivity',
                component: asyncComponent(() => loadApp('groupActivity')), // 拼团活动
                children: [],
            },
            {
                path: '/myGroup',
                component: asyncComponent(() => loadApp('myGroup')), // 我的拼团
                children: [],
            },
            {
                path: '/myFollow',
                component: asyncComponent(() => loadApp('myFollow')), // 我的关注
                children: [],
            },
            {
                path: '/groupDetails',
                component: asyncComponent(() => loadApp('groupDetails')), // 拼团详情
                children: [],
            },
            {
                path: '/mainCategory',
                component: asyncComponent(() => loadApp('mainCategory')), // 主分类页面
                children: [],
            },
            {
                path: '/subCategory',
                component: asyncComponent(() => loadApp('subCategory')), // 子类别页面
                children: [],
            },
            {
                path: '/providerSearch',
                component: asyncComponent(() => loadApp('providerSearch')), // 店铺搜索页面,
                children: [],
            },
            {
                path: '/search',
                component: asyncComponent(() => loadApp('search')), // 搜索页面,
                children: [],
            },
            {
                path: '/storeHome',
                component: asyncComponent(() => loadApp('storeHome')), // 商家首页,
                children: [],
            },
            {
                path: '/commodityDetails',
                component: asyncComponent(() => loadApp('commodityDetails')), // 商品详情页,
                children: [],
            },
            {
                path: '/evaluate',
                component: asyncComponent(() => loadApp('evaluate')), // 我的订单--发表评价,
                children: [],
            },
            {
                path: '/refund',
                component: asyncComponent(() => loadApp('refund')), // 我的订单--申请退货,
                children: [],
            },
            {
                path: '/logisticsDetails',
                component: asyncComponent(() => loadApp('logisticsDetails')), // 我的订单--查看物流,
                children: [],
            },
            {
                path: '/orderDetails',
                component: asyncComponent(() => loadApp('orderDetails')), // 我的订单--订单详情,
                children: [],
            },
            {
                path: '/confirmOrder',
                component: asyncComponent(() => loadApp('confirmOrder')), // 确认订单,
                children: [],
            },
            {
                path: '/selectCoupon',
                component: asyncComponent(() => loadApp('selectCoupon')), // 选择优惠券,
                children: [],
            },
            {
                path: '/selectAddress',
                component: asyncComponent(() => loadApp('selectAddress')), // 选择收货地址,
                children: [],
            },
            {
                path: '/newBuiltAddress',
                component: asyncComponent(() => loadApp('newBuiltAddress')), // 新建收货地址,
                children: [],
            },
            {
                path: '/mapLocation',
                component: asyncComponent(() => loadApp('mapLocation')), // 地址定位,
                children: [],
            },
            {
                path: '/mapPosition',
                component: asyncComponent(() => loadApp('mapPosition')), // 地图位置显示,
                children: [],
            },
            {
                path: '/share',
                component: asyncComponent(() => loadApp('share')), // 分享页面,
                children: [],
            }, 
        ],
    }, 
]

export default routerConfig;

